// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__5VkR4","DotContainer":"Spinner_DotContainer__1zQ7a","Dot":"Spinner_Dot__TcXtb","fade":"Spinner_fade__29iY9"};